<template>
  <ModalBody>
    <div class="price-entry q-px-lg q-pt-lg bg-white-1 shadow3 border-radius-sm overflow-hidden">
      <AgGrid
        ref="wrapper"
        :key="reRender"
        :options="options"
        :row-data="sortedGridData"
        :context="context"
        @ready="agGrid = $event"
        @cell-value-changed="cellValueChanged"
      >
        <template #header>
          <Grid justify-content="end">
            <ShowHideCols :ag-grid="agGrid" />
          </Grid>
        </template>
      </AgGrid>
    </div>
  </ModalBody>
</template>

<script>
import * as apiTo from '@/modular-api'
import { event as eventBus } from '@/plugins/event-bus'
import { getTaskData } from '../modals-shared'
import { options } from './options'
// Libraries
import { orderBy } from 'lodash'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import ModalBody from '../components/ModalBody'

export default {
  components: {
    AgGrid,
    ModalBody,
    ShowHideCols
  },

  mixins: [options],

  props: {
    periodId: [Number, String]
  },

  data() {
    return {
      reRender: 1,
      agGrid: null,
      context: {},
      gridData: null
    }
  },

  computed: {
    sortedGridData() {
      if (!this.gridData) return null
      return orderBy(this.gridData, ['vendor.name', 'publisher.name', 'name'], ['asc', 'asc', 'asc'])
    }
  },

  async created() {
    this.context = { priceEntryCmp: this }
    await this.getTaskData('price-entries').then(({ data }) => (this.gridData = data.result))
    this.$emit('set-loader', false)
  },

  methods: {
    getTaskData,

    getCount() {
      return this.gridData.length
    },

    // called from `ActionsColumn.vue`
    finalize(row) {
      this.$emit('set-loader', true)

      apiTo
        .UPDATE_TASK('price-entries', row.id, { ...row, finalized: true })
        .then(() => {
          if (this.gridData.length === 1) this.$emit('make-count-0')
          else {
            const index = this.gridData.findIndex(g => g.id === row.id)
            if (~index) this.gridData.splice(index, 1)
          }
        })
        .finally(() => this.$emit('set-loader', false))
    },

    didValueChanged(old, newVal) {
      if (typeof old === 'string' && typeof newVal === 'number') return Number(old) !== Number(newVal)
      return old !== newVal
    },

    cellValueChanged(event) {
      if (!this.didValueChanged(event.oldValue, event.newValue)) return

      apiTo
        .UPDATE_TASK('price-entries', event.data.id, event.data)
        .then(({ data }) => {
          if (this.$store.hasModule('subscription-show')) {
            this.$store.commit('subscription-show/updatePeriodPrices', data.result)
            eventBus.$emit('refreshPriceTab')
          }
        })
        .catch(async () => {
          this.$emit('set-loader', true)
          await this.getTaskData('price-entries')
          this.$emit('set-loader', false)
          this.reRender++
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.price-entry {
  @include table-with-no-filters;

  height: calc(100vh - 180px);
}
</style>
